// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessOilWellSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.14 2.059a.477.477 0 0 1 .51-.112l2.059.75a.5.5 0 0 1 .299.64L8.81 6.628l2.034.74a2 2 0 0 1 3.09 1.125l5.682 2.068a.5.5 0 0 1 .299.64l-.342.94a.5.5 0 0 1-.324.308V18h.25a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5H8L9.96 9.174l-1.834-.668-1.197 3.29a.5.5 0 0 1-.641.298l-2.06-.75a.477.477 0 0 1-.318-.412c-.091-1.319.173-3.015.799-4.734.626-1.719 1.513-3.187 2.43-4.14zm4.426 8.894L10.889 14h2.222l-.677-3.047a2.009 2.009 0 0 1-.868 0zm6.184 1.056-3.353-1.22L16 18h1.75zM10.555 15.5 10 18h4l-.556-2.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessOilWellSolid;
